import { render } from "./TransferShow.vue?vue&type=template&id=3654463f"
import script from "./TransferShow.vue?vue&type=script&lang=js"
export * from "./TransferShow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Desktop/projects/ConexionCreativa/real-gestion/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__